import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/parabens.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-65409ed2")

_pushScopeId("data-v-65409ed2")
const _hoisted_1 = { class: "flex md:flex-row flex-col items-center justify-center w-full mt-44 px-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "mockup-wrapper w-5/6 md:w-96 md:mr-10 mb-10" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "mockup relative w-full rounded-md",
    src: _imports_0,
    alt: "..."
  })
], -1)
const _hoisted_3 = { class: "flex flex-col text-center md:text-left items-center md:items-start justify-center max-w-md lg:max-w-xl md:ml-10 mt-10 md:mt-0" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", { class: "gradient-text font-bold text-3xl w-auto" }, " Compartilhe seus resultados ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-gray-700 text-md mt-5" }, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic voluptatibus magni deserunt optio, doloremque obcaecati soluta omnis quaerat illo facilis, ut ullam quidem ipsum maiores eaque quam dicta laboriosam? Assumenda. ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Aprenda mais sobre a Bíblia! ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_orange_button = _resolveComponent("orange-button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("article", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_orange_button, {
        class: "mt-8",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goto('challenges')))
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
})